module.exports = __webpack_public_path__ + "img/trending-up.6491db57.svg";